// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"79":"c0ca0ade","100":"242f43f3","140":"8c0e9ec8","234":"cfd109e8","589":"d3ad79da","680":"e032a770","727":"08e3c02d","789":"f75c56a1","794":"b72f52a8"}[chunkId] + ".chunk.js";
};